module.exports = __webpack_public_path__ + "static/media/kids_42.05215bbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_42.jpg
// module id = 5898
// module chunks = 0